import { z } from 'zod';
import { TicketBrowsePaymentStatusSchema } from './ticket-browse-schemas.js';
import { TicketStatusSchema } from './ticket-schemas.js';
// tickets-csv-export — async, streaming CSV export of the admin ticket
// browse list. Single source of truth shared by AdminTicketExportController
// (backend) and the ticket-export api-client functions (frontend). Filter
// shape mirrors TicketBrowseQuerySchema (ticket-browse-schemas.ts) minus
// pagination (cursor/limit — the export walks ALL matching rows).
export const CreateTicketExportRequestSchema = z
    .object({
    locationId: z.string().uuid().optional(),
    status: TicketStatusSchema.optional(),
    paymentStatus: TicketBrowsePaymentStatusSchema.optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    /**
     * Language of the generated file and notification emails (headers, status
     * labels, time zone rendering). Optional: clients that predate it get 'en'.
     */
    locale: z.enum(['en', 'es']).optional(),
})
    .refine((v) => !v.from || !v.to || new Date(v.from) <= new Date(v.to), {
    message: "'to' must not precede 'from'",
    path: ['to'],
});
export const CreateTicketExportResponseSchema = z.object({
    jobId: z.string().uuid(),
});
export const TicketExportStatusSchema = z.enum(['pending', 'processing', 'done', 'failed']);
export const TicketExportJobResponseSchema = z.object({
    jobId: z.string().uuid(),
    status: TicketExportStatusSchema,
    /** Presigned S3 GET url — present ONLY when status is 'done'. */
    downloadUrl: z.string().url().optional(),
    /** Failure reason — present ONLY when status is 'failed'. */
    error: z.string().optional(),
});
//# sourceMappingURL=ticket-export-schemas.js.map